export const ROUTES = {
  PUBLIC_HOME: '/',
  LOGIN: 'login',
  HOME: 'home',
  TRAIL_HOME: 'trail',
  TRAIL_DETAIL: 'trail/:trailId',
  TRAIL_BY_QR_CODE: 'trail/qr/:qrCode',
  TRAIL_CHECKIN_DETAIL: 'trail/checkin/:trailCheckinId',
  PROFILE: 'profile',
  MY_PLANS: 'plans',
  PLAN_DETAIL: 'plans/:planId',
  SIGN_IN_REDIRECT: 'sign-in-redirect',
  BACKEND_HOME: 'backend',
  LIVE_ACTIVITIES: 'backend/live-activities',
  ADMIN_WELFARE_CHECK_SETTINGS: 'admin/welfare-check-settings',
  WELFARE_CHECK_WALKER: 'welfare-check/walker/:token',
  WELFARE_CHECK_CONTACT: 'welfare-check/contact/:token',
  SHARED_PLAN: 'shared-plan/:token',
  // STUDENTS: 'students',
  // STUDENT_PROFILE: 'profile/:sId',
  // STUDENT_ENROLLED_PROGRAM: 'enrolled/:sId/:programEnrolmentId',
};
